export default function AdminHome() {
  return (
    <div className="min-h-screen px-12 py-10">
      <h1 className="display text-4xl text-elixir-cream mb-2">Panel administrador</h1>
      <p className="text-elixir-cream/60 mb-8">Métricas en tiempo real, leads, fragancias top, conversión.</p>
      <div className="card text-elixir-cream/70">
        TODO — login admin (JWT), tarjetas KPI, filtros por tienda/fecha, export CSV de leads,
        configuración de tabletas (tienda + vendedor por dispositivo).
      </div>
    </div>
  );
}
